import React, { useEffect } from 'react';
import { useLocation, useHistory, Redirect } from 'react-router-dom';
import qs from 'qs';
import styles from './index.module.scss';

import { Loader } from 'components';
import { useAuthGuard, useMutation } from 'utils/hooks';
import { logout } from 'utils/services';

export default function ExternalSignIn() {
  const { search } = useLocation();
  const { replace } = useHistory();

  const { onAuthenticated } = useAuthGuard();

  const { token, store } = qs.parse(search.slice(1));

  const { mutate: signIn } = useMutation('auth.externalLogin', 'POST', {
    payload: { token },
    ignoreReadModeCheck: true,
    errorMessage: "We couldn't log you in. Please try again.",
    onSuccess: data => onAuthenticated(data),
    onError: () => replace('/login')
  });

  useEffect(() => {
    if (token) {
      logout(() => signIn());
    }
  }, [token, signIn]);

  if (!token) return <Redirect to="/" />;

  return (
    <div className={styles.container}>
      <Loader loading spinnerClassName={styles.spinner} />
      <span className={styles.content}>
        Provisioning access to <strong>"{store || 'the store'}"</strong>...
      </span>
    </div>
  );
}
